export const version = "@ethers-ancillary/bsc@0.0.3";
